<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="msgAlerta" :mensagem="msgAlerta" />

    <div v-if="!showOSSelect" class="form-edit-page">
        <div v-if="osSelecionada" class="row row-space">
            <div class="form-item-codigo">
                <label class="label-caption">OS</label>
                <div class="field-label field-label-end">{{ osSelecionada.cdipos }}</div>
            </div>

            <div class="form-item-char10">
                <label class="label-caption">Inclusão</label>
                <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(osSelecionada.dtipos) }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">Bairro</label>
                <div class="field-label">{{ osSelecionada.nmbairro }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">Serviço</label>
                <div class="field-label">{{ osSelecionada.nmipservico }}</div>
            </div>
        </div>

        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption">Enredeço</label>
                <div class="field-label">{{ osSelecionada.nmlogradouro }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">Siruação OS</label>
                <div class="field-label">{{ osSelecionada.statusnm }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">Prestador</label>
                <div class="field-label">{{ osSelecionada.nmfornecedor }}</div>
            </div>
        </div>


        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption">Justificativa</label>
                <input type="text" v-model="edJustificativa" v-uppercase />
            </div>
        </div>


        <div class="row-end">
            <button class="btn-confirm" @click="salvarEstorno">Confirmar</button>
            <button @click="openOSSelect">Retornar</button>
        </div>
    </div>


    <div v-if="showOSSelect">
        <IpOsPesquisaPage
            :idSituacao="7"
            :idSituacao2="8"
            @cancel="cancelForm"
            @select="selecionarOS" />
    </div>


    <DialogOkModal 
      v-if="showOkModal" 
      :message="msgOkModal" 
      @close="closeOkModal" 
      @confirmed="closeOkModal" />
</template>

<script setup>
import { ref } from 'vue';
import { Funcoes } from '@/funcoes/utils';
import { genericPost } from '@/funcoes/api';
import { globalStore } from '@/globals';
import DialogOkModal from '@/components/modals/DialogOkModal.vue';
import IpOsPesquisaPage from './IpOsPesquisaPage.vue';
import MensagemAlerta from '@/components/MensagemAlerta.vue';

const emit = defineEmits(['close', 'salvo']);

const isLoading = ref(false);
const msgAlerta = ref(false);
const msgOkModal = ref('Estorno de encerramento de OS efetuado com sucesso!!!');
const showOkModal = ref(false);
const showOSSelect = ref(true);

const edJustificativa = ref(null);

// OBJETOS
const osSelecionada = ref(null);

const cancelForm = () => {emit('close');};

const closeOkModal = () => {
    emit('save');
    showOkModal.value       = false;
    showOSSelect.value      = true;
    edJustificativa.value   = null;
}

const openOSSelect = () => {
    showOSSelect.value=true;
}

const selecionarOS = (os) => {
    showOSSelect.value      = false;
    osSelecionada.value     = os;
};

const salvarEstorno = async () => {
    try{
        msgAlerta.value=null;
        if (!edJustificativa.value) throw new Error('Necessário informar uma justificativa');
        isLoading.value=true;
        const ret = await genericPost('/ip/ipos/estorno/encerramento', {
            idmunicipio: globalStore.idmunicipio,
            idos: osSelecionada.value.id,
            strparam1: edJustificativa.value,
            idlogin: globalStore.idlogin,
            idusuario: globalStore.idusuario});
        if (ret.bolok === 1){
            showOkModal.value=true;
        }else{
            msgAlerta.value=`ATENÇÃO: ${ret.erro}`;
        }
    } catch (error) {msgAlerta.value=`ATENÇÃO: ${error.message}`;
    }finally{isLoading.value=false;}
}
</script>